<h1 matDialogTitle>Outgoing Message</h1>

<mat-dialog-content>
  <div style="display: flex; flex-direction: row; gap: 16px">
    <div style="width: 60%">
      <ng-container *ngIf="dataTable && dataTable.tableConfig">
        <optsol-ngx-data-table [config]="dataTable.tableConfig" [data]="dataTable.tableData"
          (actionButtonClicked)="actionButtonClicked($event)">
        </optsol-ngx-data-table>
      </ng-container>
    </div>
    <mat-card *ngIf="textToDisplay" style="width: 40%">
      <mat-card-title-group>
        <mat-card-title>{{titleToDisplay}}</mat-card-title>
      </mat-card-title-group>
      <mat-card-content style="max-height: 400px; overflow: auto">
        {{textToDisplay}}
      </mat-card-content>
      <mat-card-actions>
        <button mat-icon-button (click)="downloadMessageResult()">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button mat-icon-button (click)="copyMessageResult()" [disabled]="!canCopyItem(selectedOutgoingMessageBinary)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>